var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
var SweepstakeBrandSettings = /** @class */ (function (_super) {
    __extends(SweepstakeBrandSettings, _super);
    function SweepstakeBrandSettings(notificationService, i18N, tokenClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        return _this;
    }
    SweepstakeBrandSettings.prototype.onActivated = function (item) {
        if (!item.setting) {
            item.setting = {
                sweepstakeId: item.currencyId,
                brandId: item.brandId,
                hasComplementary: false,
                maxComplementaryNumberPerPurchase: 0,
                brandSweepstakesSettingId: 0
            };
        }
    };
    Object.defineProperty(SweepstakeBrandSettings.prototype, "isReadonly", {
        get: function () {
            if (this.item && !this.item.navigationInfo)
                return false;
            else
                return this.item.navigationInfo.operatorId || this.item.navigationInfo.brandId && this.item.sweepstakeId > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBrandSettings.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClient.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBrandSettings.prototype, "isAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    SweepstakeBrandSettings = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            TokenClient])
    ], SweepstakeBrandSettings);
    return SweepstakeBrandSettings;
}(ChildComponent));
export { SweepstakeBrandSettings };
